import {
  Box,
  Flex,
  Heading,
  Text,
  Image,
  useMediaQuery,
} from "@chakra-ui/react";
import img1 from "../../../../assets/aboutimg1.png";
import img2 from "../../../../assets/aboutimg2.png";
import {
  bizflexLogo,
  edupaliLogo,
  verifyIcon,
} from "../../../../assets/exports";

const ThirdLayer = () => {
  const [isMobile] = useMediaQuery("(max-width: 501px)");

  return (
    <Flex
      flexDir="column"
      alignItems="center"
      minH="100vh"
      mt={isMobile ? "99px" : "137px"}
      pl={["0", "55px", "55px", "10px"]}
      pr={["0", "55px", "55px", "10px"]}
      mb={{ base: "30px", md: "63px" }}
      textAlign="center"
    >
      <Box>
        <Heading fontSize={["24px", "24px", "30px", "40px"]}>
          About Our Company
        </Heading>
        <Text
          pt={["0px", "24px"]}
          color="#222425"
          fontSize={["14px", "16px", "20px"]}
          textAlign={"center"}
        >
          FastaMoni Technologies Inc. stands at the forefront of innovative
          solutions, specializing
          <span> in revolutionizing payments across diverse sectors.</span>
        </Text>
      </Box>
      <Flex
        w="100%"
        gap="17px"
        flexDir={["column", "column", "row", "row"]}
        justifyContent="center"
        mt="60px"
      >
        <Box borderRadius="11px" overflow="hidden" pos="relative">
          <Image src={img1} w="full" />
          <Flex
            pos="absolute"
            left={4}
            top={4}
            bg="#ffff"
            px={isMobile ? "7px" : "13px"}
            justifyContent="space-between"
            py={isMobile ? "3px" : "7px"}
            gap="6px"
            alignItems="center"
            borderRadius="59px"
          >
            <Image src={verifyIcon} />
            <Text fontSize="13px" fontWeight={600}>
              Verified
            </Text>
          </Flex>
        </Box>
        <Box borderRadius="11px" overflow="hidden" pos="relative">
          <Image src={img2} w="full" />
          <Flex
            pos="absolute"
            left={4}
            top={4}
            bg="#ffff"
            px={isMobile ? "7px" : "13px"}
            justifyContent="space-between"
            py={isMobile ? "3px" : "7px"}
            gap="6px"
            alignItems="center"
            borderRadius="59px"
          >
            <Image src={verifyIcon} />
            <Text fontSize="13px" fontWeight={600}>
              Verified
            </Text>
          </Flex>
        </Box>
      </Flex>
      <Text
        maxW="1100px"
        mx="auto"
        pt="63px"
        fontSize={isMobile ? "12px" : "20px"}
        lineHeight="1.5"
      >
        Our flagship products include{" "}
        <Image
          w="85px"
          h="27px"
          display="inline"
          src={edupaliLogo}
          verticalAlign="middle"
        />
        and{" "}
        <Image
          w="68px"
          h={"22.36px"}
          display="inline"
          src={bizflexLogo}
          verticalAlign="middle"
        />
        . EduPali embodies our commitment to overcoming barriers to quality
        education in Africa, notably in Nigeria, where over 20 million students
        lack access to schools due to financial constraints and inefficient
        payment systems. BizFlex aims to streamline business operations for
        small to medium-sized enterprises (SMEs).
      </Text>
    </Flex>
  );
};
export default ThirdLayer;
